import { TransactionLine } from '../../../api/elite/types/transaction';
import { ApiNtAssemblyItemDto } from '../../../api/netsuite/dto/assembly-item';
import { SchedulerBaseItem } from '../../scheduler/models/item';

type SalesOrderInserted = TransactionLine & {
  transactionId: number;
  transactionTitle: string;
  dueDate: string;
  purchaseOrderTitle?: string;
};

type SalesOrderNetsuite = ApiNtAssemblyItemDto['openSalesOrders']['return'][0];

export class PackingBoxSalesOrderItem extends SchedulerBaseItem {
  id: number;
  get title(): string {
    return this.transactionTitle;
  }
  get priority(): boolean {
    throw new Error('Method not implemented.');
  }
  set priority(val: boolean) {
    throw new Error('Method not implemented.');
  }
  TYPE = 'SalesOrder';
  transactionId: number;
  transactionTitle: string;
  dueDate: string;

  lineId: number;
  assemblyItemId: number;
  quantityAsked: number;
  quantityPacked: number;
  partNumberByCustomer: string;
  customerId: number;
  customerName: string;
  purchaseOrderTitle: string;
  private inserted = false;
  get isInserted(): boolean {
    return this.inserted;
  }

  previousRank: string;

  static fromNetsuite(body: SalesOrderNetsuite): PackingBoxSalesOrderItem {
    const data = {
      transactionId: body.saleOrderId,
      transactionTitle: body.saleOrder,
      dueDate: body.dueDate,
      lineId: body.transactionLineId,
      assemblyItemId: body.itemId,
      quantityAsked: body.quantityAsked,
      quantityPacked: body.quantityPacked,
      rank: null,
      previousRank: null,
      partNumberByCustomer: body.partNumberByCustomer,
      customerId: body.customerId,
      customerName: body.customerName,
      purchaseOrderTitle: body?.purchaseOrderTitle,
    };
    const instance = new PackingBoxSalesOrderItem();
    Object.assign(instance, data);
    return instance;
  }
  static fromElite(body: SalesOrderInserted): PackingBoxSalesOrderItem {
    const data = {
      transactionId: body.transactionId,
      transactionTitle: body.transactionTitle,
      dueDate: body.dueDate,
      lineId: body.lineId,
      assemblyItemId: body.assemblyItemId,
      quantityAsked: body.quantityAsked,
      quantityPacked: body.stats?.totalQuantityPacked || 0,
      rank: body.rank,
      previousRank: body.rank,
      id: body.id,
      inserted: true,
      partNumberByCustomer: body?.salesOrderLineDetails?.partNumberByCustomer,
      purchaseOrderTitle: body?.purchaseOrderTitle,
    };
    const instance = new PackingBoxSalesOrderItem();
    Object.assign(instance, data);
    return instance;
  }
}
